import React from 'react';

/**
 * QUANTE COLONNE STANNO IN UNA GRIGLIA, misurando il contenitore: una
 * copertina sta fra 190 e 230 px dal computer in su, e le colonne seguono
 * la larghezza, da 4 (tablet) a 11 (un monitor da 32 pollici); sul telefono
 * tre, poi quattro da 600 px. Il numero serve a due cose: alla griglia, che
 * lo scrive nelle sue colonne (cosi' una riga e' sempre piena, senza buchi a
 * destra), e a chi decide quanti giochi mostrare (righe × colonne).
 *
 * Si misura col ResizeObserver, quindi segue anche la finestra che si
 * ridimensiona e il menu che si apre. Dove non c'e' (i test) vale la
 * larghezza della finestra. Prima della misura torna `diSerie`.
 */
const CELLA_COMPUTER = 206;
const SPAZIO_COMPUTER = 16;
const COMPUTER = 1024;
/* La copertina piu' stretta con le colonne fisse: sotto, una colonna in meno. */
const CELLA_MINIMA = 120;

export function colonnePerLarghezza(larghezza, fisse) {
  if (!larghezza) return 0;
  if (larghezza < 600) return 3;
  /* Dal computer una skin puo' volerle sempre uguali (di serie dieci): la larghezza decide solo sotto gli 800 px,
     e sopra toglie colonne solo se le copertine scenderebbero sotto CELLA_MINIMA (dieci a 1600, otto a 1100). */
  if (fisse && larghezza >= 800) {
    const stanno = Math.floor((larghezza + SPAZIO_COMPUTER) / (CELLA_MINIMA + SPAZIO_COMPUTER));
    return Math.max(4, Math.min(12, Math.round(fisse), stanno));
  }
  if (larghezza < COMPUTER) return 4;
  return Math.max(4, Math.min(11, Math.floor((larghezza + SPAZIO_COMPUTER) / (CELLA_COMPUTER + SPAZIO_COMPUTER))));
}

export default function useColonne(ref, diSerie = 4, fisse = 0) {
  const [colonne, setColonne] = React.useState(diSerie);
  React.useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const misura = () => {
      const n = colonnePerLarghezza(el.getBoundingClientRect().width || window.innerWidth, fisse);
      if (n) setColonne(n);
    };
    misura();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', misura);
      return () => window.removeEventListener('resize', misura);
    }
    const oss = new ResizeObserver(misura);
    oss.observe(el);
    return () => oss.disconnect();
  }, [ref, fisse]);
  return colonne;
}
